import { useEffect, useState } from 'react'

const proxyPath = process.env.REACT_APP_RETAIL_FINANCE_MOCK_PROXY_PATH

export const useIsInternal = () => {
  const [isInternal, setIsInternal] = useState(false)

  useEffect(() => {
    fetch(`${proxyPath}/checkpoint-mock/is_internal`)
      .then(r => (r.ok ? r.json() : null))
      .then(data => {
        if (data?.internal) setIsInternal(true)
      })
      .catch(() => {})
  }, [])

  return isInternal
}
